
const Week = (props: any) : JSX.Element => {
  return (
    <div>Week</div>
  )
}

export default Week